<template>
    <div class="col-md-5 col-md-offset-1">
        <slot name="title"></slot>
        <div v-for="(label, geoCode) in municipalities">
            <label class="text-nowrap" :class="{disabled:isInputSelected(geoCode)}">
                <input type="checkbox" name="output[]" :ref="`${geoCode}`" :value="geoCode" :disabled="isInputSelected(geoCode)"> &nbsp;<span v-text="`${label} (${geoCode})`"></span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TransferOutput',

    props: {
        selected: {
            type: String
        },
        list: {
            type: String
        }
    },

    data () {
        return {
            checkList: null,
            municipalities: null
        }
    },

    created () {
        this.municipalities = JSON.parse(this.list)

        this.$watch('selected', () => {
            const $input = this.$refs[this.selected][0]
            if ($input && $input.checked) {
                $input.checked = false
            }
        })
    },

    methods: {
        isInputSelected (geoCode) {
            return geoCode === this.selected
        },
        onClick ($event) {
            console.debug($event.target)
        }
    }

}
</script>

<style scoped>
    .disabled span {
        pointer-events: none;
        opacity: 0.5;
        user-focus: none;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/transfer-outputs.vue